// Module
var code = "<template> <require from=\"app/cm/admin/intensity/intensities\"></require> <intensities></intensities> </template> ";
// Exports
module.exports = code;